/**
 * Press Block.
 * 
 */

/**
 * Desktop: Press logos continuously scroll via gsap.
 * Mobile: ???
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

function initSlider() {
	console.log("PRESS: initSlider()");
	let
		$logo = $('.press__logo'),				// Assumes all logos are same width (180px + 24px padding).
		$logos = $('.press__logos'),			// Logos container.
		logoW = $logo.outerWidth(),
		logosTotalW = logoW * $logo.length,		// Calculate total width.
		logosW = $logos.width(),				// Width of container (window width).
		logosWidth = $logos.width(),
		startX = (logosTotalW - logosW)/2,
		endX = -logosW/2;

	let tl = gsap.timeline({
		repeat:-1,
		scrollTrigger: {
			trigger: $logos,
			start: "top bottom",
			end: "bottom top",
			id: "logos",
			// markers: true,
		}
	});

	gsap.set($logos, {x:endX});
	tl.from($logos, {duration:20, x:startX, ease:"none"});
}

function initSlickSlider() {
	console.log("PRESS: initSlickSlider()");
	let 
		// $logos = $('.press__logos');
		$logos = $('.press__logos-slides');

	$logos.slick({
		arrows:false,
		autoplay:true,
		autoplaySpeed:0,
		speed:10000,
		centerMode:true,
		cssEase:"linear",
		pauseOnHover:false,
		slidesToShow:1,
		slidesToScroll:1,
	})
}

exports.init = function () {
    // Run init methods...
    // initSlickSlider();

    $(document).ready(function() {				// Wait for page load to measure logos.
	    // initSlider();
    });
};